import { IModelEntity } from '@pit/core';
import { IDtoAddress } from './dto.address.interface';

export interface IDtoAddressee extends IModelEntity {

    name1?: string;
    name2?: string;
    name3?: string;

    address?: IDtoAddress;

    fullAddress?: string;
    fullName?: string;

}
